import { SVGAttributes } from 'react';

export const WarningIcon = (props: SVGAttributes<SVGElement>) => {
	return (
		<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g fill="none" fillRule="evenodd">
				<path d="M0 0h24v24H0z" />
				<g fill="#ea850f">
					<path d="M12 13c-.552 0-1-.45-1-1V8c0-.55.448-1 1-1s1 .45 1 1v4c0 .55-.448 1-1 1ZM11.005 16a1.002 1.002 0 0 0 2.005 0c0-.55-.448-1-1-1H12a.997.997 0 0 0-.995 1Z" />
					<path d="M12 23C5.935 23 1 18.07 1 12S5.935 1 12 1s11 4.93 11 11-4.935 11-11 11Zm0-20c-4.962 0-9 4.04-9 9s4.038 9 9 9c4.963 0 9-4.04 9-9s-4.037-9-9-9Z" />
				</g>
			</g>
		</svg>
	);
};
